import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const AUTH_BASE = process.env.REACT_APP_AUTH_BASE || "";

interface PasswordProps {
  oldPassword: string;
  newPassword: string;
  email: string;
}

export const postUpdatePassword = createAsyncThunk(
  "postUpdatePassword",
  async (passwordData: PasswordProps) => {
    const { data } = await axios.post(
      `${GATEWAY_BASE + AUTH_BASE}/v1/keycloak/resetPassword`,
      {
        previous_password: passwordData.oldPassword,
        password: passwordData.newPassword,
        email: passwordData.email,
      }
    );
    return data;
  }
);

const postUpdatePasswordSlice = createSlice({
  name: "postUpdatePassword",
  initialState: {
    loading: false,
    passwordResponse: null as any,
    error: false,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(postUpdatePassword.pending, (state, action) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(postUpdatePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.error = false;
      state.passwordResponse = action.payload;
    });
    builder.addCase(postUpdatePassword.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default postUpdatePasswordSlice.reducer;
